
import React, { Component } from 'react';
import PropTypes from "prop-types";


export default class FollowSize extends Component {

  static defaultProps = {
    subtractWidth: 0,
    subtractHeight: 0,
    setWidth: true,
    setHeight: true
  }

  static propTypes = {
    Component: PropTypes.any.isRequired,
    subtractWidth: PropTypes.number,
    subtractHeight: PropTypes.number,
    setWidth: PropTypes.bool,
    setHeight: PropTypes.bool
  }

  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth - props.subtractWidth,
      height: window.innerHeight - props.subtractHeight
    };

    this.onResizeTimeout = null;
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    this.onResizeTimeout = null;
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    clearTimeout(this.onResizeTimeout);
    this.onResizeTimeout = setTimeout(this.calculateWidth, 200);
  }

  calculateWidth = () => {
    const { subtractWidth, subtractHeight } = this.props;
    this.setState({
      width: window.innerWidth - subtractWidth,
      height: window.innerHeight - subtractHeight
    })
  }

  render() {
    const { width, height } = this.state;
    const { Component, setWidth, setHeight, subtractHeight, subtractWidth, ...componentProps } = this.props;
    let style = {};
    if (setWidth) {
      style['width'] = `${width}px`;
    }
    if (setHeight) {
      style['maxHeight'] = `${height}px`;
    }
    return (
      <Component {...componentProps} style={style}>
        {this.props.children}
      </Component>
    )
  }
}
